export const ALL_CATEGORIES_REQUEST = "ALL_CATEGORIES_REQUEST";
export const ALL_CATEGORIES_SUCCESS = "ALL_CATEGORIES_SUCCESS";
export const ALL_CATEGORIES_FAIL = "ALL_CATEGORIES_FAIL";


export const NEW_CATEGORY_REQUEST = "NEW_CATEGORY_REQUEST";
export const NEW_CATEGORY_SUCCESS = "NEW_CATEGORY_SUCCESS";
export const NEW_CATEGORY_RESET = "NEW_CATEGORY_RESET";
export const NEW_CATEGORY_FAIL = "NEW_CATEGORY_FAIL";


export const CLEAR_ERRORS = "CLEAR_ERRORS";